import DeltaPlane from 'deltaplane';
import toPath from 'lodash-es/toPath';
import template from 'lodash-es/template';
import isFunction from 'lodash-es/isFunction';
import get from 'lodash-es/get';
import set from 'lodash-es/set';
import defaultsDeep from 'lodash-es/defaultsDeep';
import merge from 'lodash-es/merge';
// import escape from 'lodash-es/escape';
import isObject from 'lodash-es/isObject';
import {rescopeFunction} from '../../../rescopeFunction';

import { renderControls, renderControl } from '../renderControls';
import { capitalizeFirst } from '../../../recharts/common';
import updateStyle from '../css/updateStyle';


const nativeEvents = [
  'click',
  'dblclick',
  'mousedown',
  'mousemove',
  'mouseout',
  'mouseover',
  'mouseleave',
  'mouseenter',
  'mouseup',
  'drag',
  'dragend',
  'dragenter',
  'dragleave',
  'dragover',
  'dragstart',
  'drop',
  'contextmenu'
];

const frameProps = [
  'top',
  'right',
  'bottom',
  'left',
  'width',
  'height',
  'position',
];

const resetProps = [
  'value',
  'isChecked',

];

const extraEl = ['styleSheet'];

export default class Control { 

  getExtraEl(){
    return extraEl;
  }

  get args(){
    return this.instance && {...this.instance.args};
  }

  constructor(instance, path, nicePath) {
    var me = this;    
    this.instance = instance;
    // console.log('new ' + nicePath);
    this.path = path;
    this.nicePath = nicePath;
    this.pathArray = toPath(path);
    this._optionsDp = DeltaPlane(this.instance.options, this.instance._patchOptions);
    this._optionsPlane = this._optionsDp.getPlane(this.pathArray);
    this._defaultShow = true;
    this._triggers = {};
    this._classList = this._controlOptions.classList||[];
    this._styleCache = {};
    this._absoluteRect = null;
    this._formatters = {};
    this._dirtyProps=[];

    this.addApi(this, 'isChecked', () => this._checkDataOption('isChecked'), {
      persistent: true,
      twoWay: true,
      formatter: 'isCheckedFormatter',
      onChange:(value,oldValue)=> me.raiseEvent('change',{value,oldValue})
    });
    this.addApi(this, 'text', () => this._checkDataOption('text'));
    this.addApi(this, 'url', () => this._checkDataOption('url'));
    this.addApi(this, 'readOnly', () => this._checkDataOption('readOnly'));
    this.addApi(this, 'disabled', () => this._checkDataOption('disabled'));
    this.addApi(this, 'visible', () => this._checkDataOption('visible', true));
    this.addApi(this, 'viewMode', () => this._controlOptions.viewMode);
    this.addApi(this, 'blur', () => this._controlOptions.blur);
    this.addApi(this, 'masked', false);
    this.addApi(this, 'name', () => this._controlOptions.name);
    this.addApi(this, 'greyscale', () => this._controlOptions.greyscale);
    this.addApi(this, 'draggable', () => this._controlOptions.draggable);
    this.addApi(this, 'draggableGrip', () => this._controlOptions.draggableGrip);
    this.addApi(this, '_isDragging', false, {onChange:(_isDragging)=>{
      if(!_isDragging) {
        this.clearStyle();
        this.render();
      }
    }});

    this.addApi(this, 'isLayoutMode', () => this._controlOptions.isLayoutMode!==undefined?this._controlOptions.isLayoutMode:this.instance.args.isLayoutMode);
    this.addApi(this, 'isDesignMode', () => this._controlOptions.isDesignMode!==undefined?this._controlOptions.isDesignMode:this.instance.args.isDesignMode);
    this.addApi(this, 'suspend',() => !this.isLayoutMode && this._controlOptions.renderControl=='never', {onChange:(suspend)=>{
      if(!suspend) {
        this.render();
      }
    }});
    this.addApi(this, 'designMode', () => this._controlOptions.designMode!==undefined?this._controlOptions.designMode:this.instance.args.designMode);

    this.addApi(
      this,
      'value',
      () =>
        this._checkDataOption(
          'value',
          this._controlOptions.value !== undefined
            ? isObject(this._controlOptions.value) && !Array.isArray(this._controlOptions.value)
              ? this._controlOptions.value.defaultValue
              : this._controlOptions.value
            : undefined
        ),
      {
        persistent: !this.isLayoutMode&&!this.isDesignMode,
        twoWay: true,
        onChange:(value,oldValue)=> me.raiseEvent('change',{value,oldValue})
      }
    );
    
    frameProps.forEach(key => this.addApi(this, key,
      () => this.getStyle(key),
      {onChange:(val)=> this.setStyle(key,val)}));    

    this.addApi(this, 'anchor');

    this.addApi(this,'effect',() => merge({}, {
        visible:false,
        repeat:'once',
        speed:'normal',
        clone:'body',
        level:0,
        style:{}
      },this._controlOptions.effect));

    this.addApi(this,'effectVisible',()=>this.effect.visible,{onChange:(value,old)=>{
      if(value!=old){
        if(value){
          this.showEffect();
        }else{
          this.hideEffect();
        }
      }
    }});
    this.addApi(this,'effectLevel',()=>this.effect.level);

    if (this._controlOptions.trigger) {
      console.log('"trigger" option is deprecated, please use "triggers"/"click" instead. '+this.nicePath);
    }

    if (this._controlOptions.event) {
      console.log('"event" option is deprecated, please use "events"/"click" instead. '+this.nicePath);
    }        

    this._onDragStart = function(e) {
      me.onDragStart(e);
    };

    this._onDragEnd = function(e) {
      me.onDragEnd(e);
    };

    this._onDragMove = function(e) {
      me.onDragMove(e);
    };

    this._onDragCancel = function(e) {
      me.onDragCancel(e);
    };

    this._onContextMenu = function(e) {
      me.onContextMenu(e);
    }

    this._onContextMenuClose = function(e) {
      me.onContextMenuClose(e);
    }

    this.raiseNativeEvent = function(e){
      me.raiseEvent(e.type,e);
    }
    
    instance.on('destroy', () => this.destroy());
    this.whenToInit();
    if(!this.isLayoutMode && this._controlOptions.renderControl=='once'){
      this.once('init',function(){
        this.suspend = true;
      });
    }
  }

/*all+single
  a + a = a
  a + o = o
  a + n = n
  o + a = o
  o + o = o
  o + n = n
  n + a = n
  n + o = n
  n + n = n
  */

  whenToInit(){
    this.instance.on('init', () => this.fire('init'));    
  }

  applyStyle(){
    if(this.el){
      frameProps.forEach((key) => {
        // console.log(`${key}: ${this.el.style[key]} <- ${this[key]}`);
        let val = get(this._controlOptions,['style','normal',key]);
        if(!(val+'').match(/[^\d.]/)){
          val = val+'px';
        }

        this.el.style[key] = val;
      });
    }
  }

  clearStyle(){
    if(this.el){
      frameProps.forEach(key => this.el.style[key] = '');
    }

    this._styleCache = {};
  }

  addClass(className){
    this._classList.push(className);
    this.el.classList.add(className);
  }

  getStyle(prop){    
    let val = get(this._controlOptions,['style','normal',prop]);
    if(val && (val+'').endsWith('px')){
      return (val+'').replace('px','');      
    }

    return val;
  }

  setStyle(prop,val){
    if(!(val+'').match(/[^\d.]/)){
      val = val+'px';
    }

    // this.instance.set
    
    this.setOption(['style','normal',prop],val);
    // set(this.options, ['style','normal',prop],val);

    // if(this.el){
    //   this.el.style[prop] = val;      
    // }

  }

  onDragStart(e) {
    const me = this;
    if (!me.isLayoutMode && me.draggable && !me._dragStart && e.isPrimary) {
      const draggableGrips = _.reduceDeep(
        me,
        (a, v, k, p, c) => {
          if (v && v.draggableGrip) {
            a.push(v.el);
          }

          return a;
        },
        [],
        { childrenPath: 'childrenControls' }
      );
      if (!draggableGrips.length) {
        draggableGrips.push(me.el);
      }

      if (draggableGrips.indexOf(e.target.closest('.controls,.io-controls')) != -1) {
        me._dragStart = {
          pointerId: e.pointerId,
          clientX: e.clientX,
          clientY: e.clientY,
        };
        me._isDragging = true;
        me.el.style.setProperty('transition-duration', '0s', 'important');
      }
    }
  }

  onDragEnd(e) {
    const me = this;
    if (me._dragStart && me._dragStart.pointerId == e.pointerId) {
      me.el.style.transitionDuration = me._dragStart.transitionDuration;
      delete me._dragStart;
      me._isDragging = false;
    }
  }

  onDragMove(e) {
    const me = this;
    if (me._dragStart && me._dragStart.pointerId == e.pointerId) {
      // if (!me._dragStart.go) {
      //   const distance = Math.sqrt(
      //     Math.pow(e.clientX - me._dragStart.clientX, 2) +
      //       Math.pow(e.clientY - me._dragStart.clientY, 2)
      //   );
      //   if (distance < 8) {
      //     return;
      //   }
      // }

      if (!me._dragStart.go) {
        me._dragStart.go = true;
        me._dragStart.transitionDuration = me.el.style.transitionDuration;        
        me.position = 'absolute';
        me.left = me.el.offsetLeft;
        me.top = me.el.offsetTop;
        me.width = me.el.offsetWidth;
        me.height = me.el.offsetHeight;
        me.right = 'auto';
        me.bottom = 'auto';
        me._dragStart.from = {
          left: me.left,
          top: me.top,
        };
        // _.assign(me.el.style, me.frameStyle);
      }

      me.top = me._dragStart.from.top + e.clientY - me._dragStart.clientY;
      me.left = me._dragStart.from.left + e.clientX - me._dragStart.clientX;      
      
      _.assign(me.el.style, { top: me.top + 'px', left: me.left + 'px' });
      // const top = me._dragStart.from.top + e.clientY - me._dragStart.clientY;
      // const left = me._dragStart.from.left + e.clientX - me._dragStart.clientX;
      // _.defer(() => {
      //   me.render();
      // });

      // me.render();
    }
  }

  onDragCancel(e) {
    const me = this;
    if (me._dragStart && me._dragStart.pointerId == e.pointerId) {
      me.position = undefined;
      me.left = undefined;
      me.top = undefined;
      me.width = undefined;
      me.height = undefined;
      me.right = undefined;
      me.bottom = undefined;
      me.el.style.transitionDuration = me._dragStart.transitionDuration;
      delete me._dragStart;
      me._isDragging = false;
      // me.render();
    }
  }

  onContextMenu(e) {
    const me = this;
    const ev = e.event && e.event.event || e;
    if(ev.button == 2){
      let cm;
      if(me.type==='contextMenu'){
        if(me._controlOptions.serieIndex!==e.seriesIndex){
          return;
        }

        cm = me;
        me.anchor = e;
      }else{
        const cmPath =  me.path+'.contextMenu';
        cm = me.instance.controls[cmPath];
      }

      // console.log('onContextMenu: ',e);
      
      ev.stopPropagation();
      ev.preventDefault();
      // console.log('onContextMenu: ',e);
      const rect = me.instance.args.element.getBoundingClientRect();
      cm.left = ev.pageX - rect.left;
      cm.top = ev.pageY - rect.top;
      cm.anchor = me.anchor;      
      if(me.type!=='contextMenu'){
        me.raiseEvent('contextMenu',e);        
      }

      cm.show();
      console.trace('onContextMenu');
    }
  }

  onContextMenuClose(e) {    
    const me = this;
    const ev = e.event && e.event.event || e;
    let cm;
    if(me.type==='contextMenu'){
      cm = me;
    }else{
      const cmPath =  me.path+'.contextMenu';
      cm = me.instance.controls[cmPath];
    }

    if(cm.visible){
      let target = ev.target;
      while(target && target!==me.instance.args.element){
        if(target===cm.el) {return;}

        target = target.parentElement;
      }

      if(me.type!=='contextMenu'){
        me.raiseEvent('contextMenuClose',e);
      }

      cm.hide();
      console.trace('onContextMenuClose'); 
    }

  }

  get tooltip() {
    return this.instance.controls[this.path+'.tooltip'];
  }

  get frameStyle() {
    return _.reduce(
      {
        position: this.position,
        left: this.left,
        top: this.top,
        width: this.width,
        height: this.height,
        right: this.right,
        bottom: this.bottom,
      },
      (r, v, k) => {
        if (!isNaN(v)) {
          v += 'px';
        }

        r[k] = v;
        return r;
      },
      {}
    );
  }

  get _controlOptions() {
    let controlOptions = get(this.instance.options, this.pathArray);
    if(!controlOptions){
      controlOptions = {};
      set(this.instance.options, this.pathArray,controlOptions)
    }

    return controlOptions;
    // return this.options;
  }

  get _controlOriginalOptions() {
    return get(this.instance.originalOptions, this.pathArray, this._controlOptions);
  }

  getOption(path, defaultValue) {
    // if (!Array.isArray(path)) {
    //   path = toPath(path);
    // }

    return get(this.options, path, defaultValue);
  }

  setOption(path, value) {
    // if (!Array.isArray(path)) {
    //   path = toPath(path);
    // }

    return set(this.options, path, value);
  }

  get options() {
    if (this._optionsDp.getOriginal() !== this.instance.options) {
      this._optionsDp = DeltaPlane(this.instance.options, this.instance._patchOptions);
      this._optionsPlane = this._optionsDp.getPlane(this.pathArray);
    }

    return this._optionsPlane;
  }

  reset() {
    resetProps.forEach((name) => {
      this['reset' + capitalizeFirst(name)]();
    });
  }

  show() {
    this.setVisible(true);
  }

  hide() {
    this.setVisible(false);
  }

  enable(){
    this.setDisabled(false);
  }

  disable(){
    this.setDisabled(true);
  }

  onChange(name,value,oldValue) {
    if (this.isDestroyed || oldValue!==undefined && value===oldValue) {
      return;
    }

    this.raiseEvent(name,{value,oldValue});
  }

  doResetReload() {
    if (this.isDestroyed) {
      return;
    }

    const options = this._controlOptions;
    const instance = this.instance;
    if (options.isReload) {
      instance.reload(this.updateDataSourceParameter(true)).then(() => {
        if (options.isReset) {
          instance.resetControls(options.isReset);
        }
      });
    } else if (options.isRefresh) {
      instance.refresh().then(() => {
        if (options.isReset) {
          instance.resetControls(options.isReset);
        }
      });
    } else if (options.isReset) {
      instance.resetControls(options.isReset);
    }
  }

  setDataSourceParameterValue(name, value = '') {
    const options = this._controlOptions;
    const params = this.instance.datasourceParameters;
    // if (Array.isArray(value)) {
    //   value = JSON.stringify(value);
    // }

    if (options.gridElement) {
      if (!params[name] || !Array.isArray(params[name])) {
        params[name] = [];
      }

      params[name][options.gridElement.rowIndex] = value;
    } else {
      params[name] = value;
    }

    return { [name]: params[name] };
  }

  updateDataSourceParameter(force) {
    // console.log('updateDataSourceParameter', this);
    const originalOptions = this._controlOriginalOptions;
    if (originalOptions.isReload && !force) {
      return;
    }

    if (
      originalOptions &&
      originalOptions.value &&
      originalOptions.value.type == 'parameterBinding'
    ) {
      if (this.isChecked !== undefined) {
        if (this.value) {
          if (this.isChecked) {
            return this.setDataSourceParameterValue(originalOptions.value.name, this.value);
          } else {
            return this.setDataSourceParameterValue(originalOptions.value.name);
          }
        } else {
          return this.setDataSourceParameterValue(originalOptions.value.name, this.isChecked);
        }
      } else if (Array.isArray(this.value)) {
        return this.setDataSourceParameterValue(
          originalOptions.value.name,
          _.map(this.value, (v) => (v.value !== undefined ? v.value : v))
        );
      } else if (this.value && this.value.value !== undefined) {
        return this.setDataSourceParameterValue(originalOptions.value.name, this.value.value);
      } else {
        return this.setDataSourceParameterValue(originalOptions.value.name, this.value);
      }
    }
  }

  get isDestroyed() {
    return this._destroyed;
  }

  destroy() {
    if(!this.isDestroyed){
      this.fire('destroy');
    }

    if (this.el) {
      this.el.remove();
      this.getExtraEl().forEach(ex => this[ex] && this[ex].remove && this[ex].remove());
      delete this.el;
      this._triggers = {};
    }

    // if (
    //   this.options.gridElement &&
    //   this.options.value &&
    //   this.options.value.type == 'parameterBinding'
    // ) {
    //   this.instance.datasourceParameters[this.options.value.name] = [];
    // }

    this._destroyed = true;
  }

  refresh(data, parentElement){
    return this.render(data, parentElement);
  }

  // Returns the immediate parent control (Toolbar / Panel / Grid / Overlay /
  // Frame / LayoutContainer / Callout / Splitter) that owns this control.
  // Returns `undefined` for top-level controls living directly under
  // `options.controls`. Set by `renderControl` in renderControls.js when the
  // control is instantiated.
  getParent() {
    return this.parentControl;
  }

  render(data, parentElement) {
    if (this.isDestroyed) {
      // console.log('control destroyed, no render');
      return;
    }

    this._absoluteRect = null;

    if(this._isDragging){
      this.applyStyle();
      return;
    }

    if (parentElement && this.parentElement !== parentElement) {
      this.parentElement = parentElement;
    }
    
    if(data!==true && this.suspend){
      return;
    }

    if(data===true){
      data = undefined;
    }

    // console.log('render ' + this._controlOptions.type);

    if (this.el && !this.parentElement.contains(this.el)) {
      // console.log('parent has no such io ' + this._controlOptions.type);
      // this.el.remove()
      delete this.el;
    }

    const oldEl = this.el;

    this.el = this.renderElement(data);



    if (this.el) {

      this._classList.forEach(cls => {
        this.el.classList.add(cls);
      });
      // console.log('parent has no this el yet', el, this.el);
      if (!this.parentElement.contains(this.el)) {
        // console.log('append io-controls el ' + this._controlOptions.type);
        this.parentElement.appendChild(this.el);
      }

      this.applyGenericOptions();
      //this.updateDataSourceParameter();

      // Double-click capture for the ChartDesigner Go-To ribbon — wired ONCE
      // per recharts instance on its root element, not per control. Capture
      // phase so it beats normal dblclick handlers. The listener walks from
      // event.target up the DOM, picking the FIRST ancestor whose .el matches
      // a known control — that's the innermost control under the cursor,
      // which is what the user wants when they double-click a button nested
      // inside a panel. (A per-control capture listener would fire outer-first
      // and the panel would win.)
      //
      // Note: the two underlying single clicks DO still fire their normal
      // handlers (e.g. button trigger in design mode) — `dblclick` only fires
      // after them. Suppressing those would require manual click-counting
      // with a timeout which is brittle. In layout mode there are no
      // triggers to worry about; in design mode the user is intentionally
      // exercising the control by clicking it twice quickly.
      const inst = this.instance;
      if (inst && !inst._designClickWired && inst.args && inst.args.element) {
        const root = inst.args.element;
        inst._designClickWired = true;
        root.addEventListener('dblclick', function(ev) {
          var node = ev.target;
          var hit = null;
          while (node && node !== root && !hit) {
            var ctrls = inst.controls || {};
            for (var p in ctrls) {
              if (ctrls[p] && ctrls[p].el === node) { hit = ctrls[p]; break; }
            }

            node = node.parentElement;
          }

          if (!hit) { return; }
          ev.preventDefault();
          ev.stopPropagation();
          // Clear the browser's word-selection from the double-click before
          // firing the event — otherwise the highlighted text remains.
          if (window.getSelection) {
            try { window.getSelection().removeAllRanges(); } catch (e) {}
          }

          inst.fire('designSelect', {
            control: hit,
            path: hit.path,
            nicePath: hit.nicePath,
            type: hit.type,
            name: hit._controlOptions && hit._controlOptions.name
          });
        }, true);
      }
    } else {
      // console.warn(`DOM element for ${this._controlOptions.type} was not created.`);
    }

    this.raiseEvent('render');

    if(!this._ready){
      this._ready = true;
      const me = this;

      function onClickOutside(e){
        let target = e.target;
        while(target && target!==me.el){
          target = target.parentElement
        }

        if(target) {return;}

        me.fire('clickOutside',e);
      }
 
      document.addEventListener('click', onClickOutside);
      this.onReady();
      this.raiseEvent('ready');      
      this.on('destroy',()=>{
        document.removeEventListener('click', onClickOutside);
      })
    }else{
      // this.raiseEvent('init');
    }

    Object.keys(this._dirtyProps).forEach(prop => {
      if(this._dirtyProps[prop]){
        this._dirtyProps[prop] = false;
      }
    });

    return this.el;
  }

  onReady(){
    //to be implemented in children
    if(this.effect.visible){
      this.showEffect();
    }
  }

  _checkDataOption(name, defaultValue) {
    const defaultName = `default${capitalizeFirst(name)}`;
    const options = this._controlOptions;
    if (!this._ignoreData) {
      if (
        options &&
        options.data &&
        (typeof options.data !== 'object' || Array.isArray(options.data))
      ) {
        throw new Error(`Unsupported ${options.type || 'control'}(${options.name}).data type.`);
      }

      if (options && options.data && options.data[name] !== undefined) {
        return options.data[name];
      }

      if (options && options.data && options.data[defaultName] !== undefined) {
        return options.data[defaultName];
      }
    }

    const res =
      options &&
      ((options[name] !== undefined && !isObject(options[name])) || Array.isArray(options[name]))
        ? options[name]
        : defaultValue;
    if (res && name == 'value' && res.defaultValue) {
      return res.defaultValue;
    }

    return res;
  }

  applyGenericOptions() {
    const options = this._controlOptions;
    if (this.options.visible === undefined || this.options.visible === null) {
      this.options.visible = true;
    }

    if (this._defaultShow) {
      if (!this.visible) {
        if (this.options.originalDisplay === undefined) {
          this.options.originalDisplay = this.el.style.display;
        }

        // if (this.options.originalOpacity === undefined) {
        //   this.options.originalOpacity = this.el.style.opacity;
        // }

        this.el.style.display = 'none';
        // this.el.style.opacity = 0;
      } else {
        if(this.options.originalDisplay!==undefined){
            this.el.style.display = this.options.originalDisplay;
          delete this.options.originalDisplay;
        }

        // if(this.options.originalOpacity!==undefined){
        //     this.el.style.display = this.options.originalOpacity;
        //   delete this.options.originalOpacity;
        // }
      }
    }

    if (this.blur && this.greyscale) {
      this.el.classList.add('dim-fast');
      this.el.classList.remove('bw-fast');
      this.el.classList.remove('blur-fast');
    } else if (this.blur) {
      this.el.classList.add('blur-fast');
      this.el.classList.remove('dim-fast');
      this.el.classList.remove('bw-fast');
    } else if (this.greyscale) {
      this.el.classList.add('bw-fast');
      this.el.classList.remove('dim-fast');
      this.el.classList.remove('blur-fast');
    } else {
      this.el.classList.remove('bw-fast');
      this.el.classList.remove('dim-fast');
      this.el.classList.remove('blur-fast');
    }

    if(this.masked){
      this.el.classList.add('masked');
    }else{
      this.el.classList.remove('masked');
    }

    this.el.dataset.path = this.path;
    if(options.originalPath!==undefined){
      this.el.dataset.originalPath = options.originalPath;      
    }

    let ttext = '';
    if(options.tooltip){
      if(options.tooltip.copyFrom){
        ttext = get(this,options.tooltip.copyFrom,'');
        if(ttext!==undefined){
          options.tooltip.text = ttext;          
        }
      }

      if(options.tooltip.type=='basic'){


        if(!ttext && options.tooltip.text){
          ttext = options.tooltip.text;
        }

      }else {
        
        if(!options.tooltip.$processed){

          options.tooltip.$processed = true;
          options.tooltip.type = 'callout';

          defaultsDeep(options.tooltip,{
            showOn:'hover',
            attachTo:'parent',
            // Tooltips dismiss themselves on hover-out — a close button is
            // both unnecessary and not exposed in the tooltip's metadata.
            // Suppress the Callout class's default closeButton.visible:true.
            closeButton: { visible: false }
          });

          // if(!options.tooltip.visible) {options.tooltip.visible = false;}

          set(options.tooltip, 'icon.style.normal.position','absolute');
          // if(options.tooltip.showOn=='hover'&&options.tooltip.attachTo!=='icon'&&!_.get(options.tooltip, 'panel.style.normal.transition')){
          //   set(options.tooltip, 'panel.style.normal.transition','opacity 300ms ease-in-out 700ms');
          // }else{
          //   set(options.tooltip, 'panel.style.normal.transition','opacity 300ms ease-in-out 0ms');
          // }

          options.tooltip.style = options.tooltip.icon.style;
          options.tooltip.url = options.tooltip.icon.url;

          defaultsDeep(options.tooltip,{
            panel:{
              style:{
                normal:{
                  padding:'8px',
                  zIndex:'500500'
                }
              }
            }
          });
          // const cmControls = options.tooltip.controls;
          
          // options.tooltip.controls=[{...options.tooltip, controls:cmControls}];        
          
        }

        // if(!this.isLayoutMode){
        //   this.el.addEventListener('tooltip', this._ontooltip);
        // }

        const cmPath = this.path+'.tooltip';
        // renderControls(this.instance, cmPath,this.nicePath);
        renderControl(this.instance, options.tooltip, cmPath,this.nicePath + ' / tooltip',this, this.el);
        // const cm = this.instance.controls[cmPath+'.controls[0]'];
        // cm.parentControl = this;
        // this.childrenControls[cmPath] = cm;
      }

      // if(!this.isLayoutMode&&(options.tooltip||this.type=='tooltip')){
      //   this.instance.args.element.addEventListener('mousedown', this._ontooltipClose);        
      // }
      

    }

    if (this.isLayoutMode || this.isDesignMode) {
      if(ttext) {ttext +=' | ';}

      ttext += this.nicePath;
    }

    if(ttext) {ttext = recharts.stripHtml(ttext);}

    if(options.tooltip && options.tooltip.type=='basic'||this.isLayoutMode || this.isDesignMode){
      this.el.setAttribute('title', ttext);      
    }


    if (options.gridElement) {
      this.gridElement = options.gridElement;
    }

    if (this.draggable && !this.isLayoutMode && !this.isDesignMode) {
      this.instance.args.element.addEventListener('pointerdown', this._onDragStart);
      this.instance.args.element.addEventListener('pointerup', this._onDragEnd);
      window.document.addEventListener('pointerup', this._onDragEnd);
      this.instance.args.element.addEventListener('pointermove', this._onDragMove);
      this.instance.args.element.addEventListener('pointercancel', this._onDragCancel);
      this.instance.args.element.addEventListener('pointerout', this._onDragCancel);
      // console.log('drag events added', this.instance.args.element);
    }

    if(options.contextMenu){
      if(!options.contextMenu.$processed){

        options.contextMenu.$processed = true;

        options.contextMenu.type='contextMenu';
        if(!options.contextMenu.visible) {options.contextMenu.visible = false;}

        set(options.contextMenu, 'style.normal.position','absolute');

        // const cmControls = options.contextMenu.controls;
        
        // options.contextMenu.controls=[{...options.contextMenu, controls:cmControls}];        
        
      }

      if(!this.isLayoutMode){
        this.el.addEventListener('contextmenu', this._onContextMenu);
      }

      const cmPath = this.path+'.contextMenu';
      // renderControls(this.instance, cmPath,this.nicePath);
      renderControl(this.instance, options.contextMenu, cmPath,this.nicePath + ' / contextMenu',this);
      // const cm = this.instance.controls[cmPath+'.controls[0]'];
      // cm.parentControl = this;
      // this.childrenControls[cmPath] = cm;
    }

    if(!this.isLayoutMode&&(options.contextMenu||this.type=='contextMenu')){
      this.instance.args.element.addEventListener('mousedown', this._onContextMenuClose);        
    }

    if(this.effectVisible && this.effect.repeat=='controlled'){      
      this.updateEffect();
    }

    nativeEvents.forEach(ev=>this.el.addEventListener(ev, this.raiseNativeEvent));

  }

  updateEffect(effect={},reset){
    defaultsDeep(effect,{level:this.effectLevel},this.effect);        
    const bodyEl = this.el.getElementsByClassName('body')[0];
    if(!bodyEl){
      throw new Error('Control has no body, effect not supported');
    }

    let effectEl = bodyEl.previousElementSibling;    
    if(reset && effectEl&&effectEl.classList.contains('effect')){
      effectEl.remove();
      effectEl = null;
      delete this.currentEffectStyle;
    }

    
    let newEl=false;
    if(!effectEl){
      effectEl = bodyEl.cloneNode(effect.clone=='full');      
      effectEl.classList.remove('body');
      newEl = true;
      effectEl.classList.add('effect');      
      if(effect.repeat!=='controlled'){
        effectEl.classList.add('ghost-'+effect.repeat+'-'+effect.speed);      
      }
    }

    effect.style.pointerEvents = 'none!important';

    if(effect.repeat=='controlled'){      
      effect.style.transitionProperty = 'opacity,transform';
      effect.style.transitionDuration = effect.speed=='fast'?300:(effect.speed=='slow'?700:500);
      effect.style.transitionTimingFunction = 'ease-in-out';
      effect.style.opacity = 1-effect.level;
      effect.style.transform = `scale(${1+effect.level})`;
    }
    
    updateStyle(effectEl, effect.style, this.currentEffectStyle);
    this.currentEffectStyle = effect.style;


    if(newEl){
      bodyEl.parentNode.insertBefore(effectEl, bodyEl);    
    }
  }

  showEffect(effect={}){
    this.effectVisible=true;
    this.updateEffect(effect,true);
    this.setStyle('overflow','visible');
    this.render();
  }

  hideEffect(){
    this.effectVisible=false;
    const bodyEl = this.el.getElementsByClassName('body')[0];
    if(!bodyEl){
      throw new Error('Control has no body, effect not supported');
    }

    let effectEl = bodyEl.previousElementSibling;
    if(effectEl&&effectEl.classList.contains('effect')){
      effectEl.remove();
      delete this.currentEffectStyle;
      this.setStyle('overflow',undefined);
      this.render();
    }

  }

  addApi(host, name, getDefault, options = {}) {
    const _name = `_${name}`;
    const formatterPath = options.formatter!==undefined?options.formatter:`${name}Formatter`;
    const Name = capitalizeFirst(name);
    const rawName = `raw${Name}`;
    const _rawName = `_raw${Name}`;
    const isDefaultName = `is${Name}Default`;
    const defaultName = `default${Name}`;
    const _defaultName = `_default${Name}`;
    const postName = `post${Name}`;
    const isDirtyName = `is${Name}Dirty`;
    const _isDirtyName = `_is${Name}Dirty`;


    host[_name] = undefined;
    host._dirtyProps[name] = true;

    if (!host._api) {
      host._api = [];
    }

    if (!host._api.includes(name)) {
      host._api.push(name);
    }

    Object.defineProperty(host, isDefaultName, {
      configurable: true,
      get: () => {
        host[`_checkDefault${Name}`]();
        return host[_name] === undefined;
      },
    });

    Object.defineProperty(host, isDirtyName, {
      configurable: true,
      get: () => {
        return host._dirtyProps[name];
      },
    });

    Object.defineProperty(host, defaultName, {
      configurable: true,
      get: () => {
        if (options.persistent && host._controlOptions.persistent) {
          const key = `recharts.persistent.${host.instance.args.cid}:${host.path}.${name}`;
          const value = localStorage.getItem(key);
          if (value !== null) {
            return JSON.parse(value);
          }
        }

        return isFunction(getDefault)?getDefault():getDefault;
      },
    });

    Object.defineProperty(host, rawName, {
      configurable: true,
      get: () => {
        let res;
        if (!host[isDefaultName]) {
          res = host[_name];
        } else {
          res = host[defaultName];
        }

        if (host[postName]) {
          res = host[postName](res);
        }

        return res;
      },
    });

    Object.defineProperty(host, name, {
      configurable: true,
      get: () => {
        let res = host[rawName];

        // Try new formatter path first, then fall back to old 'formatter' for backwards compatibility
        let formatter = get(host._controlOptions,formatterPath);
        let actualFormatterPath = formatterPath;

        // Legacy fallback: pre-v4.46.26 specs used a generic `formatter` key
        // for the TEXT/HTML-producing API (label, panel). Only fall through
        // for the `text` API — every control also has `visible` / `readOnly` /
        // `disabled` / `url` APIs whose formatter paths would otherwise route
        // to the same generic `formatter`, running a user's text-shaped
        // function on booleans/urls and throwing.
        if(!formatter && formatterPath !== 'formatter' && name === 'text'){
          // For nested paths like 'label.textFormatter', try 'label.formatter'
          const fallbackPath = formatterPath.includes('.')
            ? formatterPath.replace(/\w+Formatter$/, 'formatter')
            : 'formatter';

          formatter = get(host._controlOptions, fallbackPath);
          if(formatter){
            actualFormatterPath = fallbackPath;
          }
        }

        //const sFormmatter = formatter+'';
        if(formatter){
          // Check if there's a binding in the original options
          // If so, skip formatter on static value - only run on bound result
          const originalOption = host._controlOriginalOptions && host._controlOriginalOptions[name];
          const hasBinding = originalOption && (
            (originalOption.binding && originalOption.binding.type === 'binding') ||
            (Array.isArray(originalOption) && originalOption[0] && originalOption[0].type === 'binding')
          );

          // Skip formatter if data hasn't loaded yet from datasource (value is undefined)
          if(hasBinding && res === undefined){
            return res;
          }

          // If there's a binding, check if this is the static value or the bound result
          // Static value is typically a primitive (string, number, boolean)
          // Bound result from binding system is usually an object (unless the datasource returns a primitive)
          const isStaticValue = hasBinding && (
            typeof res === 'string' ||
            typeof res === 'number' ||
            typeof res === 'boolean' ||
            res === null
          ) && originalOption.staticValue === res;

          // Skip formatter if this is a static value with binding
          if(hasBinding && isStaticValue){
            return res;
          }

          if(typeof formatter == 'string'){

            if(!host._formatters[actualFormatterPath]||host._formatters[actualFormatterPath].src!=formatter){
              host._formatters[actualFormatterPath] = template(formatter);
              host._formatters[actualFormatterPath].src = formatter;
            }

            // Backward-compat: expose `value`, `text`, `html`, the API-name key,
            // and `oldValue` (Feb-2023 default) as aliases for the current value
            // so legacy templates (${value}, ${html}, ${text}, ${oldValue}) resolve
            // regardless of which API the formatter is attached to. Lodash
            // template runs in strict mode and throws ReferenceError on missing
            // identifiers — every supported placeholder must be in this object.
            res = host._formatters[actualFormatterPath]({
              text:res, value:res, html:res, [name]:res,
              oldValue: undefined,
              control:host, component:host.instance, parentControl:host.parentControl,
              chart: host.instance && host.instance.chart,
              dataSource: host.instance && host.instance.getDataSource(),
              data: host.instance && host.instance.data,
              fn: host.instance && host.instance.fn,
              app: host.instance && host.instance.app
            });

          }else{
            if(!host._formatters[actualFormatterPath]||host._formatters[actualFormatterPath]._original!=formatter){
              const scope = {
                control:host,
                component:host.instance, // Backward compatibility: old formatters used 'component'
                parentControl:host.parentControl,
                chart:host.instance && host.instance.chart,
                dataSource:host.instance && host.instance.getDataSource(),
                // Backward compatibility: expose the current value under several
                // alias names so legacy free-var references work regardless of
                // which API the formatter targets. All updated at call time.
                [name]: undefined, // API-specific name (text / url / value / isChecked / …)
                value: undefined,  // legacy: function(){ return value; }
                text: undefined,   // legacy: function(){ return text; }
                html: undefined,   // legacy: function(){ return html; } (panel)
                oldValue: undefined // Feb 2023 schema default placeholder — exposed so
                                     // `${oldValue}` / free-var `oldValue` resolves to undefined
                                     // instead of throwing ReferenceError
              };
              Object.defineProperty(scope, 'data', {
                get() { return host.instance && host.instance.data; },
                enumerable: true
              });
              Object.defineProperty(scope, 'fn', {
                get() { return host.instance && host.instance.fn; },
                enumerable: true
              });
              host._formatters[actualFormatterPath] = rescopeFunction(host._formatters[actualFormatterPath]||formatter, scope, host);

              // Detect second parameter name to determine what to pass as arg2
              // function(text, control) → pass control instance
              // function(html, component) → pass component instance
              // Also handles arrow forms: (x, y) => ...  or  x => ...
              const fStr = formatter.toString();
              const pMatch = fStr.match(/function\s*\(([^)]*)\)/)
                          || fStr.match(/^\s*\(([^)]*)\)\s*=>/)
                          || fStr.match(/^\s*([A-Za-z_$][A-Za-z0-9_$]*)\s*=>/);
              const params = pMatch ? pMatch[1].split(',').map(function(p){ return p.trim(); }) : [];
              host._formatters[actualFormatterPath]._arg2 = params[1] === 'component' ? 'component' : 'control';
            }

            try{
              // Update the scope with current value for backward compatibility.
              // Mirror the value across every alias so legacy free-vars resolve:
              //   - [name]  : the canonical API name (text / url / value / isChecked)
              //   - value   : Feb 2023 schema default and modern `function(value)` default
              //   - text    : text-shaped APIs' canonical
              //   - html    : legacy panel formatter
              const _scope = host._formatters[actualFormatterPath]._scope;
              _scope[name] = res;
              _scope.value = res;
              _scope.text = res;
              _scope.html = res;

              const arg2 = host._formatters[actualFormatterPath]._arg2 === 'component' ? host.instance : host;
              res = host._formatters[actualFormatterPath](res, arg2);
            }catch(ex){
              const _iArgs = host.instance && host.instance.args;
              const _ctrlType = host.type || '';
              const _compName = (host.instance && host.instance.options && host.instance.options.chartName) || (_iArgs && _iArgs.name) || '';
              // Compact human-readable path — names joined by "/" with
              // terminal slots (tooltip / contextMenu) appearing as their
              // slot name. Same format the Control Navigator emits in its
              // pill display (pathStart + pathRest) and accepts as paste
              // input. Derived from the runtime nicePath ("type name /
              // type name / …") by dropping the type token from each
              // segment.
              let _humanPath = '';
              if (host.nicePath) {
                _humanPath = host.nicePath.split(' / ').map(function(seg) {
                  var idx = seg.indexOf(' ');
                  return idx === -1 ? seg : seg.slice(idx + 1);
                }).join('/');
              } else if (host.path) {
                _humanPath = host.path;
              }
              // Which designer tab hosts this control:
              //   io     — root ancestor is the ioEnabled toolbar (controls[0])
              //   popup  — root ancestor is an overlay
              //   canvas — everything else
              let _tab = 'canvas';
              try {
                const _rootIdx = host.path ? parseInt((host.path.match(/^controls\[(\d+)\]/) || [])[1], 10) : NaN;
                const _rootOpts = !isNaN(_rootIdx)
                  && host.instance && host.instance.options
                  && host.instance.options.controls && host.instance.options.controls[_rootIdx];
                if (_rootOpts) {
                  if (_rootOpts.ioEnabled) { _tab = 'io'; }
                  else if (_rootOpts.type === 'overlay') { _tab = 'popup'; }
                }
              } catch (e) { /* keep 'canvas' */ }
              console.error(`[formatter] "${actualFormatterPath}" failed [component: "${_compName}", type: "${_ctrlType}", tab: "${_tab}", path: "${_humanPath}"]`, ex);
              res = 'Formatter error: ' + (ex.message||ex);
            }
          }
        }

        return res;
      },
      set: (value) => {
        const old = host[rawName];
        // const oldRaw = host[_rawName];
        // host[_rawName] = value;        

        host[_name] = value;
        host[_defaultName] = host[defaultName];
        if (options.persistent && host._controlOptions.persistent) {
          const key = `recharts.persistent.${host.instance.args.cid}:${host.path}.${name}`;
          if (value == undefined) {
            localStorage.removeItem(key);
          } else {
            localStorage.setItem(key, JSON.stringify(value));
          }
        }

        if (options.twoWay) {
          const originalOptions = this._controlOriginalOptions;
          if (
            originalOptions &&
            originalOptions[name] &&
            originalOptions[name].binding &&
            originalOptions[name].binding.twoWay
          ) {
            this.instance.setVariable(
              originalOptions[name].binding.variable.path,
              value && value.value !== undefined ? value.value : value
            );
          }
        }

        if(old!==value){          
          host._dirtyProps[name] = true;
        }

        host.onChange(name, value, old);
        if(options.onChange){
          options.onChange(value, old);
        }
      },
    });

    host[`get${Name}`] = function() {
      return host[name];      
    };

    host[`set${Name}`] = function(value) {
      const changed = host[rawName]!==value;
      host[name] = value;
      if(changed){
        host.render();        
      }
    };

    host[`reset${Name}`] = function() {
      host[`set${Name}`]();
    };

    host[`_checkDefault${Name}`] = function() {
      if(options.twoWay){
        const originalOptions = this._controlOriginalOptions;
        if (
          host[_name]!==undefined &&
          originalOptions &&
          originalOptions[name] &&
          originalOptions[name].binding &&
          originalOptions[name].binding.twoWay &&
          host[defaultName]!==host[_defaultName]
        ){
          host[_name] = undefined;
        }
      }
    };
  }

  on(event, handler) {
    this.addTrigger(event, handler);
  }

  addTrigger(event, handler) {
    event = event.split(',');
    _.each(event, (e) => {
      if (!this._triggers[e]) {
        this._triggers[e] = [];
      }

      if(this._triggers[e].indexOf(handler)===-1){
        this._triggers[e].push(handler);          
      }
    });
  }

  once(event, handler) {
    this.addOneTimeTrigger(event, handler);
  }

  addOneTimeTrigger(event, handler) {
    this.addTrigger(event, handler);

    function clear() {
      // setTimeout(()=> {
        this.removeTrigger(event, handler);
        this.removeTrigger(event, clear);
      // }, 0);
    }

    this.addTrigger(event, clear);
  }


  off(event, handler) {
    this.removeTrigger(event, handler);
  }  

  removeTrigger(event, handler) {
    event = event.split(',');
    _.each(event, (e) => {
      if (this._triggers[e]) {
        handler.skip = true;
        setTimeout(()=>{
          _.pull(this._triggers[e], handler);          
        },0);
      }
    });
  }

  fire(){
     this.raiseEvent.apply(this, arguments);
  }

  raiseEvent() {
    const eventName = arguments[0];    
    const args = _.drop(arguments);
    
    if(this._triggers[eventName]){
      //for(let e=0;e<this._triggers[eventName].length;e++){
      for(const handler of this._triggers[eventName]){
        if (!isFunction(handler)) {
          console.error('trigger should be a function', handler);
          return;
        }

        if(handler.skip) {continue;}

        // triggers added from scripts, not from to options, should be as is
        //this._triggers[eventName][e] = rescopeFunction(this._triggers[eventName][e],{control:this, parentControl:this.parentControl}, this);

        try {
          handler.apply(this, [eventName,this,this.instance,this.anchor||{},args]);
        } catch (exc) {
          const _ctrlName = this._controlOriginalOptions && this._controlOriginalOptions.name || '';
          const _ctrlType = this.type || (this._controlOptions && this._controlOptions.type) || '';
          const _iArgs = this.instance && this.instance.args;
          const _compName = (this.instance && this.instance.options && this.instance.options.chartName) || (_iArgs && _iArgs.name) || '';
          const _compCid = (_iArgs && _iArgs.cid) || '';
          const _compLabel = _compName ? (_compCid ? `${_compName} [${_compCid}]` : _compName) : _compCid;
          console.error(`[control trigger] Event "${eventName}" failed [component: "${_compLabel}", control: "${_ctrlName}", type: "${_ctrlType}", path: "${this.path || ''}"]`, exc);
        }
      }
    }

    if(this._controlOptions.triggers && this._controlOptions.triggers[eventName]){
      if (!isFunction(this._controlOptions.triggers[eventName])) {
        console.error('trigger should be a function', this._controlOptions.triggers[eventName]);
      } else {
        const controlInstance = this.instance;
        const scope = {
          control:this,
          parentControl:this.parentControl,
          anchor:this.anchor||{},
          eventData:args,
          chart:controlInstance && controlInstance.chart,
          dataSource:controlInstance && controlInstance.getDataSource()
        };
        Object.defineProperty(scope, 'data', {
          get() { return controlInstance && controlInstance.data; },
          enumerable: true
        });
        Object.defineProperty(scope, 'fn', {
          get() { return controlInstance && controlInstance.fn; },
          enumerable: true
        });
        this._controlOptions.triggers[eventName] = rescopeFunction(this._controlOptions.triggers[eventName], scope, this);
        try {
          this._controlOptions.triggers[eventName].apply(this, [eventName,this,this.instance,this.anchor||{},args]);
        } catch (exc) {
          const _ctrlName = this._controlOriginalOptions && this._controlOriginalOptions.name || '';
          const _ctrlType = this.type || (this._controlOptions && this._controlOptions.type) || '';
          const _iArgs = this.instance && this.instance.args;
          const _compName = (this.instance && this.instance.options && this.instance.options.chartName) || (_iArgs && _iArgs.name) || '';
          const _compCid = (_iArgs && _iArgs.cid) || '';
          const _compLabel = _compName ? (_compCid ? `${_compName} [${_compCid}]` : _compName) : _compCid;
          console.error(`[control trigger] Event "${eventName}" failed [component: "${_compLabel}", control: "${_ctrlName}", type: "${_ctrlType}", path: "${this.path || ''}"]`, exc);
          console.log('Trigger:', this._controlOptions.triggers[eventName]);
        }
      }
    }

    if(this.options.events && this.options.events[eventName]){
      let ev = this.options.events[eventName];
      if(ev===true) {ev = eventName;}

      this.instance.fire(
        ev,
        this,
        this.instance,
        this.anchor||{},
        args
      );      
    }

    if(!eventName){
      console.log('Event name is empty');
      console.trace();
      return;
    }

    if(!eventName.endsWith('Parent')){
      _.each(this.childrenControls, ctrl => ctrl.raiseEvent(eventName+'Parent',...args));
    }
  }

  getEventPosition(ev) {
    const container = this.instance.args.element.getBoundingClientRect();
    return {
      top: ev.clientY-container.top,
      left: ev.clientX-container.left,
      width: 0,
      height: 0,
    };
  }

  getAbsoluteRect() {

    if(!this._absoluteRect) {
      const container = this.instance.args.element.getBoundingClientRect();
      if(this.el){
        const ctrl = this.el.getBoundingClientRect();
        this._absoluteRect = {    
          top: ctrl.top - container.top,
          left: ctrl.left - container.left,
          width: ctrl.width,
          height: ctrl.height,      
        };
      }else{
        const parent = this.parentControl && this.parentControl.el.getBoundingClientRect() || container;
        const ctrl = this;
        this._absoluteRect = {    
          top: parseInt(ctrl.top) + parent.top - container.top,
          left:parseInt(ctrl.left) + parent.left - container.left,
          width:parseInt(ctrl.width),
          height:parseInt(ctrl.height),      
        };

      }
    }

    return this._absoluteRect;
  }
}
